<button
  *ngIf="isSupported"
  type="button"
  class="btn voice-btn"
  [class.listening]="isListening"
  [disabled]="disabled"
  [attr.aria-label]="(isListening ? 'CHATBOT_VOICE_STOP' : 'CHATBOT_VOICE_START') | translate"
  (click)="toggleListening()">
  <i class="bi" [class.bi-mic-fill]="isListening" [class.bi-mic]="!isListening"></i>
</button>
